<div class="main-modal documents-popup-common accessorial-documents-modal">
  <div class="modal_header d-flex align-items-center justify-content-between">
    <div class="modal_header_inner d-flex align-items-center">
      <span class="material-icons green-text modal-header-icon mr-2">description</span>
      <h3 class="modal_title fw-600">Accessorial Cost Documents</h3>
    </div>
    <button type="button" mat-dialog-close class="close_modal" (click)="onClose()">
      <i class="material-icons">close</i>
    </button>
  </div>

  <div class="modal-body">
    <div class="doc-content" *ngIf="documents.length > 0; else noDocuments">
      <div class="doc-file-header-row">
        <span>Document Name</span>
        <span>Uploaded On</span>
        <span class="text-center">Action</span>
      </div>
      <div class="doc-file-row" *ngFor="let document of documents">
        <div class="doc-file-name" [title]="(document.name || 'Document') | fileDisplayName">
          <img class="doc-type-icon" [src]="(document.name || document.key || document.signedUrl) | fileTypeIcon" alt="file icon" />
          <span>{{ (document.name || 'Document') | fileDisplayName }}</span>
        </div>
        <span class="text-center">{{ getDisplayUploadedOn(document) }}</span>
        <div class="doc-file-actions">
          <a href="javascript:void(0)" (click)="onViewDocument(document)">View</a>
          <span class="separator">|</span>
          <a href="javascript:void(0)" (click)="onDownloadDocument(document)">Download</a>
        </div>
      </div>
    </div>

    <ng-template #noDocuments>
      <div class="no-documents">No documents available</div>
    </ng-template>
  </div>

  <div class="modal-footer d-flex justify-content-end">
    <button type="button" mat-button class="btn btn-close-modal" (click)="onClose()">
      Close
    </button>
  </div>
</div>
